import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { postBooking } from "../../../app/api/postBooking";
import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IPassenger } from "../../../Orchestrator/Types/Index";
import { ICalculatePassengerListByPriceActionParams } from "../../../Orchestrator/Types/Interface/ActionParams/BookItAgainActionParams";
import { IDefaultActionResult } from "../../../Orchestrator/Types/Interface/ActionParams/DefaultActionResult";
import { IBookingRequest, IBookingResponse } from "../../../Orchestrator/Types/Types/BookingTypes";
import { prepareBookingSummaryAction } from "../../LogicActions/Checkout/Summary/PrepareBookingSummaryAction";
import { calculatePassengerListByPriceAction } from "../../LogicActions/Search/CalculatePassengerListByPriceAction";
dayjs.extend(timezone);
dayjs.extend(utc);

export class BookItAgainContinueButtonAction extends BaseAction<IDefaultActionResult, IDefaultActionResult> {
  
    //No more used this function so removed it.   

    override async run(): Promise<IDefaultActionResult> {
        let actionResult: IDefaultActionResult = {
            data: null,
            message: "",
            status: "fail"
        }
        try {
            const { data, status } = this.params!
            if (data && status === "success") {
                if (data?.needToHide) {
                    updateRecoilState("isModalVisibleAtom", false);
                    updateRecoilState("isRoundTripInboundModalVisibleAtom", false);
                    updateRecoilState("isRoundTripModalVisibleAtom", false);
                }                
                const newBookingRequest: IBookingRequest = data?.newBookingRequest                
                updateRecoilState('bookingResponseAtom', null);

                // Post booking data to the API            
                const response: any = await postBooking(newBookingRequest);
                if (response.status === 'ok' && response.answer) {
                    const bookingResponse: IBookingResponse = response.answer;

                    if (actionResult) {
                        actionResult.data = bookingResponse.booking
                    }

                    // Update Recoil state with the booking response
                    updateRecoilState('bookingResponseAtom', bookingResponse);

                    prepareBookingSummaryAction.setParams(bookingResponse.booking)
                    await prepareBookingSummaryAction.execute()

                    const params: ICalculatePassengerListByPriceActionParams = {
                        booking: bookingResponse.booking,
                        screen: "",
                        passengerSpecificationsTypes: null
                    }
                    await calculatePassengerListByPriceAction.setParams(params)
                    await calculatePassengerListByPriceAction.execute()


                    if (bookingResponse.booking.passengers.length >= 1) {
                        updateRecoilState("selectedPassengerForCancelAtom", bookingResponse.booking.passengers.map((d: IPassenger) => d.id))
                        if (bookingResponse.booking.trips.length > 1) {
                            updateRecoilState("selectedPassengerForCancelInBoundAtom", bookingResponse.booking.passengers.map((d: IPassenger) => d.id))
                        }
                    }
                    actionResult.status = "success"
                }
            }
        }
        catch (error) {
            console.log("Error during booking again:", error);
            actionResult.message = "Something went wrong"
        } finally {
            return actionResult
        }
    }
}

export const bookItAgainContinueButtonAction = new BookItAgainContinueButtonAction(); 